var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('vehicle-form',{attrs:{"loading":_vm.loading,"vehicleData":_vm.vehicle,"formErrors":_vm.formErrors,"showCustomer":true,"showMecanic":true},on:{"vehicleSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }